module.exports = __webpack_public_path__ + "static/media/icon-cookies.4e828549.svg";